var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var EyeO = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 909.4 522.17", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M467.78 101.08c-88.23 0-160 71.78-160 160s71.77 160 160 160 160-71.77 160-160-71.78-160-160-160zm0 256a96 96 0 1 1 96-96 96.1 96.1 0 0 1-96 96z" }),
            React.createElement("path", { className: "cls-1", d: "M858.47 286.89l-106.84 78.35a479 479 0 0 1-136.22 69.7 479.71 479.71 0 0 1-147.63 23.23 479.73 479.73 0 0 1-147.64-23.23 479 479 0 0 1-136.22-69.7L77.08 286.89a32 32 0 0 1 0-51.61l106.84-78.35a479.78 479.78 0 0 1 567.71 0l106.84 78.35a32 32 0 1 0 37.85-51.61l-106.84-78.35a543.78 543.78 0 0 0-643.41 0L39.23 183.67a96 96 0 0 0 0 154.83l106.84 78.35a542.91 542.91 0 0 0 154.39 79 543.59 543.59 0 0 0 167.32 26.33 543.57 543.57 0 0 0 167.31-26.33 542.91 542.91 0 0 0 154.39-79l106.84-78.35a32 32 0 0 0-37.85-51.61z" }))))); };
export default EyeO;
//# sourceMappingURL=EyeO.js.map